// extracted by mini-css-extract-plugin
export default {"eligible_valid":"checkeligible_eligible_valid__yfZHH","eligible_novalid":"checkeligible_eligible_novalid__F5BDG","table_container":"checkeligible_table_container__Qk7nH"};